import { Component, type ErrorInfo, type ReactNode } from "react";

/**
 * Without this a render error unmounts the whole app and the admin sees an empty grey page. This shows what failed
 * (so it can be reported) and offers a reload; `resetKey` (the current URL) clears it when the admin navigates away.
 */
export class ErrorBoundary extends Component<{ children: ReactNode; resetKey: string }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: ErrorInfo) { console.error("screen_crashed", error, info.componentStack); }
  componentDidUpdate(prev: { resetKey: string }) { if (prev.resetKey !== this.props.resetKey && this.state.error) this.setState({ error: null }); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div style={{ maxWidth: 560, margin: "15vh auto", padding: 24, textAlign: "center", fontFamily: "system-ui, sans-serif", color: "#191c1d" }}>
        <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 8 }}>这个页面出错了 / This page hit an error</div>
        <div style={{ fontSize: 13, color: "#534434", marginBottom: 16 }}>请截图下面的信息发给开发人员，然后刷新页面。</div>
        <pre style={{ textAlign: "left", whiteSpace: "pre-wrap", background: "#f3f4f5", borderRadius: 10, padding: 12, fontSize: 12, maxHeight: 180, overflow: "auto" }}>
          {`${this.state.error.name}: ${this.state.error.message}\n${window.location.pathname}`}
        </pre>
        <button type="button" onClick={() => window.location.reload()} style={{ marginTop: 16, padding: "10px 20px", borderRadius: 10, border: 0, background: "#ea580c", color: "#fff", fontWeight: 700, cursor: "pointer" }}>刷新页面 / Reload</button>
      </div>
    );
  }
}
